import {
  matchConfigurationData,
  matchConfigurationDataWithDefault,
  matchDefaultConfigurationData,
} from '@/lib/utils/crm/matchConfigurationData';
import { GetExportDataReturn } from '../';

export const transformGetExportDataShape = (
  exportData: GetExportDataReturn | null
) => {
  if (!exportData) throw new Error('No export data to transform');
  const survey = exportData.survey?.[0];
  if (!survey) throw new Error('No survey data to transform');
  const crm_config = survey.crm_config;
  const surveyWithoutCrmConfig = { ...survey };
  delete surveyWithoutCrmConfig.crm_config;
  const temp = {
    crm: {
      ...exportData.crm,
      configuration: exportData.crm?.configuration,
      default_configuration: exportData.crm?.default_configuration,
      configuration_data: exportData.crm?.configuration_data,
      selected_configuration: exportData.crm?.selected_configuration,
    },
    crm_project: {
      ...exportData.crm_project,
      selected_configuration: exportData.crm_project?.selected_configuration,
    },
    crm_config: {
      ...crm_config,
      selected_configuration: crm_config?.selected_configuration,
    },
    project: {
      archived: exportData.archived,
      challenge: exportData.challenge,
      created_at: exportData.created_at,
      id: exportData.id,
      name: exportData.name,
      manager_id: exportData.manager_id,
    },
    survey: {
      ...surveyWithoutCrmConfig,
    },
    organization: exportData.organisation,
    matched_configuration: exportData.crm
      ? matchConfigurationData(
          exportData.crm,
          exportData.crm.configuration,
          exportData.crm_project ?? undefined,
          crm_config ?? undefined
        )
      : null,
    default_matched_configuration: exportData.crm
      ? matchDefaultConfigurationData(
          exportData.crm,
          exportData.crm_project ?? undefined,
          crm_config ?? undefined
        )
      : null,
    matched_configuration_with_default: exportData.crm
      ? matchConfigurationDataWithDefault(
          exportData.crm,
          exportData.crm_project ?? undefined,
          crm_config ?? undefined
        )
      : null,
  };
  return temp;
};
